import React from "react";
import { connect } from "react-redux";
import type { RootState } from "../../../redux/appState";
import ConfigurationsList from "./ConfigurationsList";
import ConfigurationDetail from "./ConfigurationDetail";

const ConfigurationsPanel = ({ view }: { view: "list" | "detail" }) =>
  view === "detail" ? (
    <ConfigurationDetail />
  ) : (
    <div className="configurations-panel configurations-list-view">
      <ConfigurationsList />
    </div>
  );

const mapStateToProps = (state: RootState) => ({
  view: state.coilConfigurator.configurations.view,
});

export default connect(mapStateToProps)(ConfigurationsPanel);
